/**
 * Subscription Feature Constants
 * Centralized feature names and subscription tier definitions
 */

export const SUBSCRIPTION_FEATURES = {
  // Mission and Content
  MISSION_STATEMENT: 'Write sustainability mission statement',
  
  // Score Visibility
  VIEW_ALO_SCORE: 'View Alō Score',
  VIEW_PILLAR_SCORES: 'View pillar scores',
  VIEW_CATEGORY_SCORES: 'View category scores',
  
  // Gallery Uploads - Hotel/Property
  HOTEL_GALLERY_2: 'Upload 2 photos to Hotel Gallery',
  HOTEL_GALLERY_10: 'Upload 10 photos to Hotel Gallery', // If exists for higher tiers
  
  // Gallery Uploads - Sustainability
  SUSTAINABILITY_GALLERY_2: 'Upload 2 photos to Sustainability Gallery',
  SUSTAINABILITY_GALLERY_10: 'Upload 10 photos to Sustainability Gallery',
  
  // Video Upload
  VIDEO_UPLOAD_1: 'Upload 1 video to Sustainability Gallery',
  
  // Support Features
  EMAIL_SUPPORT: 'Access email support',
  LIVE_CHAT_SUPPORT: 'Access live chat support',
  
  // Certifications Auto-populate
  AUTO_POPULATE_BREEAM: 'Auto-populate BREEAM certification',
  AUTO_POPULATE_GREEN_KEY_GLOBAL: 'Auto-populate Green Key Global certification',
  AUTO_POPULATE_GREEN_KEY_INTERNATIONAL: 'Auto-populate Green Key International certification',
  AUTO_POPULATE_LEED: 'Auto-populate LEED certification',
  
  // Assessment
  COMPLETE_ASSESSMENT: 'Complete assessment during annual open period',
  UPDATE_ASSESSMENT: 'Update assessment during annual open period',
  
  // GBTA
  UPLOAD_GBTA_STANDARDS: 'Upload and apply GBTA Sustainable Procurement Standards',
} as const;

export const SUBSCRIPTION_TIERS = {
  FREE: 'FREE',
  BASIC: 'BASIC',
  ESSENTIALS: 'ESSENTIALS',
  BOOST: 'BOOST',
} as const;

// Type helpers
export type SubscriptionTier = typeof SUBSCRIPTION_TIERS[keyof typeof SUBSCRIPTION_TIERS];
export type SubscriptionFeatureName = typeof SUBSCRIPTION_FEATURES[keyof typeof SUBSCRIPTION_FEATURES];

// Feature categories for easier grouping
export const FEATURE_CATEGORIES = {
  GALLERY: [
    SUBSCRIPTION_FEATURES.HOTEL_GALLERY_2,
    SUBSCRIPTION_FEATURES.HOTEL_GALLERY_10,
    SUBSCRIPTION_FEATURES.SUSTAINABILITY_GALLERY_2,
    SUBSCRIPTION_FEATURES.SUSTAINABILITY_GALLERY_10,
  ],
  VIDEO: [
    SUBSCRIPTION_FEATURES.VIDEO_UPLOAD_1,
  ],
  SCORES: [
    SUBSCRIPTION_FEATURES.VIEW_ALO_SCORE,
    SUBSCRIPTION_FEATURES.VIEW_PILLAR_SCORES,
    SUBSCRIPTION_FEATURES.VIEW_CATEGORY_SCORES,
  ],
  CERTIFICATIONS: [
    SUBSCRIPTION_FEATURES.AUTO_POPULATE_BREEAM,
    SUBSCRIPTION_FEATURES.AUTO_POPULATE_GREEN_KEY_GLOBAL,
    SUBSCRIPTION_FEATURES.AUTO_POPULATE_GREEN_KEY_INTERNATIONAL,
    SUBSCRIPTION_FEATURES.AUTO_POPULATE_LEED,
  ],
} as const;
